<template>
  <div>
    <h3 class="title-head">RFID Enrollment</h3>
    <p class="kiosk-status">No kiosks are available to print.</p>
    <p class="main-content">
      {{ mainContent }}
    </p>

    <p class="main-content" v-if="userListWithoutEmailAndPhone">
      {{ userListWithoutEmailAndPhone }}.
    </p>

    <p class="main-content">
      {{ extraContent }}
    </p>
    <div class="h-line"></div>
    <div clas="buttons-con">
      <!-- if confirmation (Continue , cancel) -->
      <template v-if="buttons.continue && buttons.cancel">
        <div
          class="submitting-btn d-flex align-items-center justify-content-center"
        >
          <button
            class="submit-btn btn btn-primary"
            @click="showRfidMassAction"
          >
            Continue
          </button>
          <button
            class="btn btn-outline-danger"
            @click="$bvModal.hide('rfid-enrollment-confirmation-modal')"
          >
            Cancel
          </button>
        </div>
      </template>

      <!-- if confirmation (Okay) only -->
      <template v-else-if="buttons.okay">
        <div class="okay-con d-flex align-items-center justify-content-center">
          <button
            class="submit-btn btn btn-primary"
            style="margin-inline-end: 0px"
            @click="$bvModal.hide('rfid-enrollment-confirmation-modal')"
          >
            Okay
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      mainContent: "",
      extraContent: "",
      userListWithoutEmailAndPhone: "",
      buttons: null,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  methods: {
    ...mapActions("users", ["setRfidMassActionUsersData"]),
    showRfidMassAction() {
      this.setRfidMassActionUsersData({
        users: this.getModalInfo.users,
        kiosksNotAvailable: true,
      });
      this.$router.push({
        params: { rfidMassAction: true },
        name: "rfidEnrollmentMassAction",
      });
    },
  },
  beforeMount() {
    this.mainContent = this.getModalInfo.mainContent;
    this.extraContent = this.getModalInfo.extraContent;
    this.userListWithoutEmailAndPhone =
      this.getModalInfo.userListWithoutEmailAndPhone;
    this.buttons = this.getModalInfo.buttons;
  },
};
</script>
<style lang="scss">
div#rfid-enrollment-confirmation-modal {
  // background: #F3F3F3;
  div#rfid-enrollment-confirmation-modal___BV_modal_content_ {
    background: #ffffff;
    border-radius: 26px;
    width: 579px !important;
    margin-top: 120px;
    margin-bottom: 100px;
    h3.title-head {
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 40px;
      color: #000000;
    }
    p.kiosk-status {
      font-weight: 700;
      font-size: 16px;
      line-height: 25px;
      /* identical to box height */
      margin: 0px auto 16px auto;
      text-align: center;
      width: 469px;
      color: #787878;
    }
    p.main-content {
      font-weight: 400;
      font-size: 16px;
      line-height: 28px;
      /* or 178% */

      text-align: center;
      letter-spacing: 0.25px;
      margin: auto;
      /* #939393 */
      width: 469px;
      color: #939393;
    }
    .h-line {
      // width: 488px;
      height: 1px;
      background: #707070;
      opacity: 0.15;
      margin: 40px auto 20px auto;
    }
    button.submit-btn.btn.btn-primary {
      width: 112px;
      height: 33px;

      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      display: flex;
      margin-inline-end: 31px;
      align-items: center;
      justify-content: center;
      border-radius: 18px;
      color: #ffffff;
    }
    button.btn.btn-outline-danger {
      width: 112px;
      height: 33px;

      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 18px;
    }
    .buttons-con {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
